import { Button, ButtonProps } from 'antd';
import { useAnalytics } from 'context/AnalyticsContext';

interface TrackerButtonProps extends ButtonProps {
  // Optional label for tracking events if button doesn't have text children
  trackerLabel?: string;
}

const TrackerButton = (props: TrackerButtonProps) => {
  const { trackerLabel, ...restProps } = props;
  const { analytics } = useAnalytics();

  const handleTrackerClick: TrackerButtonProps['onClick'] = (event) => {
    let finalLabel = trackerLabel;
    if (!finalLabel && typeof props.children === 'string') {
      finalLabel = props.children.toString();
    }

    if (finalLabel) {
      analytics?.track(`${finalLabel} Clicked`);
    }

    props?.onClick?.(event);
  };
  return <Button {...restProps} onClick={handleTrackerClick} />;
};

export default TrackerButton;
